import { observer } from "mobx-react";
import { useRootStore } from "@/stores/RootStoreContext";
import { useEffect } from "react";
import { LoadingIndicator } from "@/components-v2/LoadingIndicator";
import { toQueryString } from "@/utils/queryParams";

const SigningCompletedBankIdCallbackPage = observer(function SigningCompletedBankIdCallbackPage() {
  const { queryParams } = useRootStore();
  const companyName = queryParams["signing-complete-company"];
  const history = useRootStore().history;
  useEffect(() => {
    const url = `/portfolio/all/companies/${toQueryString({ "signing-complete": true, "signing-complete-company": companyName })}`;
    history.replace(url);
  }, [history, companyName]);
  return <LoadingIndicator />;
});

export default SigningCompletedBankIdCallbackPage;
